import styled from '@emotion/styled';

export interface DividerProps {
  color?: string | ((props: any) => string) | undefined;
  width?: string;
  margin?: string;
}

const fnCall = (variable: any, props: any) => {
  return typeof variable === 'function' ? variable(props) : variable;
};

export const Divider = styled.div<DividerProps>`
  width: ${(props) => props.width ?? '27px'};
  height: 1px;
  background-color: ${(props) =>
    fnCall(props.color, props) ?? props.theme.colors.foreground};
  margin: ${(props) => props.margin ?? '16px 0'};
`;
